<div class="search-fields-settings" [class.grid-view-settings]="dialogData.type.includes('grid')">
  <div class="pop-header">
    <div class="left">
      <img src="/assets/css/images/platform/modify-settings.png" />
      <label class="label">{{translate('galis_js_SearchForm_ModifySearch')}}</label>
    </div>
    <div class="right" (click)="cancelGridSettings()">
      <img src="/assets/css/images/platform/close-icon.png" />
    </div>
  </div>

  <div class="title-div">
    <label class="fields-main-label">{{translate('galis_js_AdditionalDisplayFields')}}</label>

  </div>

  <div class="drag-drop-content">
    <div class="left-container">
      <div class="info">
        <label>{{translate('galis_js_SearchForm_AvailibleFields')}}:</label>
        <input type="text" placeholder="{{translate('galis_js_SearchForm_FindPlaceholder')}}"
          (input)="fieldSearch($event.target.value)" />
          <img src="/assets/css/images/platform/shape.png" />
        </div>

        <div class="all-search-fields grid-fields">
          <ul>
            <ng-scrollbar [visibility]="'hover'">
              @for (item of gridAvailibleFields; track item) {
                <li [ngClass]="{'active': selectedGridField == item}" (click)="listItemClick($event, item)"
                  (dblclick)="doubleClickAdd($event, item)"
                  [matTooltip]="item.Translation" [matTooltipPosition]="'left'" matTooltipClass="searchproperty-tooltip">
                  {{ item.Translation }}
                </li>
              }
            </ng-scrollbar>
          </ul>
        </div>

      </div>

      <!-- dialogData.type == 'list' || dialogData.type.includes('grid') -->
      <div class="action-buttons">
        <div class="add" (click)="addGridField()" [ngClass]="{'remove': addAllowed(),'remove cancel-div': !addAllowed()}"
        style="background-image:url(/assets/css/images/platform/add-right@3x.png)"></div>
        <div class="remove" (click)="removeAddedGridField()"
        style="background-image:url(/assets/css/images/platform/add-left@3x.png)"></div>
      </div>

      @if (dialogData.type == 'list' || dialogData.type.includes('grid')) {
        <div class="right-container">
          <label>{{translate('galis_js_SearchForm_YourSettings')}}:</label>
          <div class="added-search-fields" (cdkDropListDropped)="drop($event)" cdkDropList>
            <ul>
              <ng-scrollbar [visibility]="'hover'">
                @for (item of gridAddedFields; track item) {
                  <li [ngClass]="{'active': selectedGridField == item}" (click)="listItemClick($event, item)"
                    (dblclick)="doubleClickRemove($event, item)" cdkDrag
                    [matTooltip]="item.Translation" [matTooltipPosition]="'right'" matTooltipClass="searchproperty-tooltip">
                    {{ item.Translation }}
                  </li>
                }
              </ng-scrollbar>
            </ul>
          </div>
        </div>
      }

      <!--div *ngIf="dialogData.type == 'grid' || dialogData.type == 'grid-large'" class="assign-content"-->
      @if (dialogData.type == 'not-now') {
        <div class="assign-content">
          <div class="prop-assigner">
            <div (click)="addGridField()" class="assign"></div>
            @if (gridViewFields[0]) {
              <input type="text" [(ngModel)]="gridViewFields[0].Translation" />
            }
            @if (!gridViewFields[0]) {
              <input type="text"/>
            }
          </div>
          <div (click)="removeAssign()" class="remove-assign"></div>
          <div class="prop-assigner">
            @if (gridViewFields[1]) {
              <input type="text" [(ngModel)]="gridViewFields[1].Translation"/>
            }
            @if (!gridViewFields[1]) {
              <input type="text"/>
            }
          </div>
          <div class="prop-assigner">
            @if (gridViewFields[2]) {
              <input type="text" [(ngModel)]="gridViewFields[2].Translation"/>
            }
            @if (!gridViewFields[2]) {
              <input type="text"/>
            }
          </div>
          <div class="prop-assigner">
            @if (gridViewFields[3]) {
              <input type="text" [(ngModel)]="gridViewFields[3].Translation"/>
            }
            @if (!gridViewFields[3]) {
              <input type="text"/>
            }
          </div>
        </div>
      }

    </div>
    @if (dialogData.type == 'list' || dialogData.type.includes('grid')) {
      <span class="right-span">{{translate('galis_js_SearchForm_DragLabel')}}</span>
    }

    <div class="footer">
      <div class="left-footer" (click)="restoreGridSettings()">
        <span>{{translate('galis_js_SearchForm_RestoreButton')}}</span>
      </div>
      <div class="right-footer">
        <!--<div class="apply" (click)="applySearchSettings()">
        <span>APPLY</span>
      </div>-->
      <div class="save" (click)="saveUserAdditionalGridFields(false)">
        <span>{{translate('galis_js_SearchForm_SaveButton')}}</span>
      </div>
      <div class="cancel" (click)="cancelGridSettings()">
        <span>{{translate('galis_js_SearchForm_CancelButton')}}</span>
      </div>
    </div>
  </div>
</div>
